import * as React from 'react';
import { colors } from '../../employees/styles/personalakteStyles';

interface ClearAllModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

function ClearAllModal({ open, onClose, onConfirm }: ClearAllModalProps) {
  if (!open) return null;

  return (
    <div
      className="glass-modal-backdrop"
      style={{
        position:'fixed', top:0,left:0,right:0,bottom:0,
        display:'flex', alignItems:'center', justifyContent:'center',
        zIndex: 5001
      }}
    >
      <div
        className="glass-modal"
        style={{
          width:'400px',
          padding:'24px',
          fontSize:'0.9rem'
        }}
      >
        <h2 style={{ marginTop:'0', fontSize:'1.1rem', color: colors.navy, fontWeight: 700 }}>Clear All Assignments</h2>
        <p style={{ color: colors.textMuted }}>Are you sure you want to remove all shift assignments? This action cannot be undone.</p>

        <div style={{ marginTop:'20px', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
          <button
            onClick={onClose}
            className="glass-btn glass-btn-secondary"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              backgroundColor: colors.danger, color:'#fff',
              border:'none', borderRadius:'8px',
              padding:'8px 16px', cursor:'pointer',
              fontSize:'12px', fontWeight: 600
            }}
          >
            Unassign All
          </button>
        </div>
      </div>
    </div>
  );
}

export default ClearAllModal;
